/**
 * @generated SignedSource<<f4dbf875d6c59e2210ebc8e04dc5df54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetSignalOverviewUpdateInput = {
  setTeamIds?: ReadonlyArray<string> | null;
};
export type WSSignalOverviewMutation$variables = {
  storecastId: string;
  update: WidgetSignalOverviewUpdateInput;
  widgetId: string;
};
export type WSSignalOverviewMutation$data = {
  readonly dashboard: {
    readonly updateWidgetSignalOverview: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetSignalOverview_widget">;
    };
  };
};
export type WSSignalOverviewMutation = {
  response: WSSignalOverviewMutation$data;
  variables: WSSignalOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  },
  {
    "kind": "Variable",
    "name": "update",
    "variableName": "update"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v10 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSSignalOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetSignalOverview",
            "kind": "LinkedField",
            "name": "updateWidgetSignalOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetSignalOverview_widget"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSSignalOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetSignalOverview",
            "kind": "LinkedField",
            "name": "updateWidgetSignalOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/),
              {
                "alias": "signalContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": "SignalConnection",
                        "kind": "LinkedField",
                        "name": "signals",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SignalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Signal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "priority",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreZonedDate",
                                    "kind": "LinkedField",
                                    "name": "publishedAtDate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "style",
                                            "value": "DEFAULT"
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "storeFormattedDate",
                                        "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "employeeReceiverReceiptsCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Store",
                                    "kind": "LinkedField",
                                    "name": "store",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "employeeCount",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreProduct",
                                    "kind": "LinkedField",
                                    "name": "linkedProducts",
                                    "plural": true,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "descriptionImages",
                                    "plural": true,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "descriptionFiles",
                                    "plural": true,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": "signals(first:20)"
                      },
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "WidgetSignalOverviewContentMedium__signals",
                        "kind": "LinkedHandle",
                        "name": "signals"
                      }
                    ],
                    "type": "WidgetSignalOverviewContentMedium",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ab345b6d44b716371aba398a3a2d2bb",
    "id": null,
    "metadata": {},
    "name": "WSSignalOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WSSignalOverviewMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $update: WidgetSignalOverviewUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetSignalOverview(id: $widgetId, update: $update) {\n      id\n      ...WidgetSignalOverview_widget\n      teams {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment SignalOverviewListItemMedium_Signal on Signal {\n  id\n  title\n  priority\n  publishedAtDate {\n    ...StoreFormattedDate\n  }\n  employeeReceiverReceiptsCount\n  store {\n    employeeCount\n    id\n  }\n  linkedProducts {\n    id\n  }\n  descriptionImages {\n    id\n  }\n  descriptionFiles {\n    id\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment WidgetSignalOverviewContentMediumPaginated on WidgetSignalOverview {\n  teams {\n    id\n  }\n  signalContent: content {\n    __typename\n    ... on WidgetSignalOverviewContentMedium {\n      signals(first: 20) {\n        edges {\n          node {\n            id\n            ...SignalOverviewListItemMedium_Signal\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment WidgetSignalOverview_widget on WidgetSignalOverview {\n  id\n  title\n  teams {\n    id\n  }\n  ...WidgetSignalOverviewContentMediumPaginated\n}\n"
  }
};
})();

(node as any).hash = "9783208d5282402fd74aff509ff4768d";

export default node;
